// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__3ZMGf","footer":"ModalCreateQualiphyProcedure_footer__qlCsy","additionData":"ModalCreateQualiphyProcedure_additionData__1FsJd"};